<script lang="ts" setup>
import type { DocumentToDownload } from '~~/server/api/forms/form'

export interface FormKitCustomDownloadProps {
    file: DocumentToDownload
}

const props = defineProps<FormKitCustomDownloadProps>()
</script>
<template>
  <div class="formkit-outer">
    <div class="mb-2 fs-smaller">
      {{ $t('Tlačivo na stiahnutie') }}
    </div>
    <div
      class="formkit-custom-download-wrapper rounded-1 p-4 position-relative d-flex align-items-start"
    >
      <svg
        class="text-secondary me-2 d-block"
        width="12"
        height="16"
        aria-hidden="true"
      >
        <use xlink:href="#download" />
      </svg>
      <a
        class="stretched-link"
        data-preview-disabled="true"
        :href="props.file.slug"
        target="_blank"
      >
        {{ props.file.title }}
      </a>
    </div>
    <IconsWrapper>
      <IconsSymbolDownload />
    </IconsWrapper>
  </div>
</template>
<style lang="scss" scoped>
@import './FormKitCustomDownload.scss';
</style>
